import { Globals } from "../CoreApp/Globals";

export function XML_DrawPlanIconPDF(
  sx,
  sy,
  width,
  height,
  lineLen,
  fillColor,
  strokeColor,
  type,
  layer,
  drawElement
) {
  var s = drawElement.GetStream();
  drawElement.OutputElementHead(s, "icon");
  drawElement.OutputSimpleElement("iconType", type, s);
  drawElement.OutputElementTriple("iconPos", sx, sy, lineLen, s);

  drawElement.OutputElementPair("iconDimensions", width, height, s);
  drawElement.OutputElementPair("colors", fillColor, strokeColor, s);
  drawElement.OutputElementTail(s, "icon");
}
